import React, { useState } from 'react';
import SessionList from '../Stats/SessionList';
import SessionFilters from '../Stats/SessionFilters';
import './GolfStats.css';

const GolfStats = () => {
  const [selectedSession, setSelectedSession] = useState(null);
  const [filters, setFilters] = useState({
    dateRange: { start: null, end: null },
    locations: [],
    launchMonitors: []
  });

  const handleSessionSelect = (sessionId) => {
    setSelectedSession(prevSelected => 
      prevSelected === sessionId ? null : sessionId
    );
  };

  const handleFilterChange = (newFilters) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      ...newFilters
    }));
  };

  return (
    <div className="golf-stats-container">
      <h2>Your Golf Sessions</h2>
      
      <div className="filter-controls">
        <SessionFilters 
          filters={filters}
          onFilterChange={handleFilterChange}
        />
      </div>
      
      <div className="sessions-container">
        <SessionList 
          filters={filters}
          selectedSession={selectedSession}
          onSessionSelect={handleSessionSelect}
        />
      </div>
    </div>
  );
};

export default GolfStats;
